import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { environment } from '@open-portal-env';
import { ClaimDetailsService } from '@open-portal-app/core/services/claim-details.service';

@Component({
  selector: 'claim-details',
  templateUrl: './claim-details.component.html',
  styleUrl: './claim-details.component.scss'
})
export class ClaimDetailsComponent {
  apiEndpoint!: string;
  claimDetail!: any;

  constructor(
    private route: ActivatedRoute,
    private claimDetailsService: ClaimDetailsService,
    private location: Location
  ) {}

  ngOnInit(): void {
    const userClaims = this.route.snapshot?.data?.userData?.claims || [];
    this.apiEndpoint = environment.apiEndpoint;
    const filteredClaim = userClaims.find((claim: any) => claim.slug === this.route.snapshot.params.claimUuid);

    const isTpaClaim = !!(filteredClaim?.tpa_partner && Object.keys(filteredClaim?.tpa_partner).length > 0);
    this.claimDetail = {
      isTpaClaim: isTpaClaim,
      claimNumber: isTpaClaim ? filteredClaim?.tpa_claim_id : filteredClaim?.claim_number,
      dateSubmitted: filteredClaim?.lodgement_date,
      dateCreated: filteredClaim?.created,
      eventTypeLabel: isTpaClaim ? filteredClaim?.tpa_claim_type :
        this.claimDetailsService.getClaimType(filteredClaim?.product_type, filteredClaim?.event_type),
      status: this.claimDetailsService.getClaimStatus(isTpaClaim, isTpaClaim ? filteredClaim?.tpa_claim_status : filteredClaim?.state),
      statusVariant: this.claimDetailsService.getClaimStatusVariant(isTpaClaim ? filteredClaim?.tpa_claim_status : filteredClaim?.state),
      tpaPartnerDetails: filteredClaim?.tpa_partner,
      tpaClaimType: isTpaClaim ? filteredClaim?.tpa_claim_type : filteredClaim?.product?.class,
      tpaSupportPhone: filteredClaim?.tpa_support_phone,
      tpaSupportEmail: filteredClaim?.tpa_support_email
    }
  }

  goBack(): void {
    this.location.back();
  }

  dialPartnerNumber(phoneNumber: string): void {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber.replace(/\s+/g, '')}`;
    }
  }

  openEmailClient(email: string) {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  }
}
